import apiFetch from '../apiFetch'

export default function (idTransportista) {
  return apiFetch({endPoint: `Combos/getComboConductoresTransportistaDeterminado?idTransportista=${idTransportista}`, method: 'GET', body: null})
}